export default "__VITE_ASSET__DoQ56WsI__"